import { C, STROKE, Figure, Label, arrow } from './figureStyle';

const ID = 'fig-fejlfinding';

// Samme trin, rækkefølge og ord som tjeklisten på /radiator-varmer-ikke
const STEPS = [
  ['Tjek om fremløbsrøret', 'overhovedet er lunt'],
  ['Afmontér termostathovedet', 'og massér ventilstiften'],
  ['Luft radiatoren ud', 'for opsamlet luft'],
  ['Tjek anlægstrykket på', 'varmecentralens manometer'],
  ['Kontrollér om naboer eller', 'andre rum mangler varme'],
];

const BOX_H = 46;
const GAP = 22;
const TOP = 8;

export default function FejlfindingFigure() {
  return (
    <Figure
      id={ID}
      height={TOP * 2 + STEPS.length * BOX_H + (STEPS.length - 1) * GAP}
      title="Fejlfinding i fem trin fra top til bund: tjek om fremløbsrøret overhovedet er lunt, afmontér termostathovedet og massér ventilstiften, luft radiatoren ud for opsamlet luft, tjek anlægstrykket på varmecentralens manometer, og kontrollér om naboer eller andre rum mangler varme."
      caption="Fejlfindingsrækkefølgen fra tjeklisten: fra fremløbsrøret over ventilstiften, udluftningen og anlægstrykket til resten af ejendommen."
    >
      {STEPS.map((lines, i) => {
        const y = TOP + i * (BOX_H + GAP);
        return (
          <g key={lines[0]}>
            <rect
              x="24"
              y={y}
              width="312"
              height={BOX_H}
              rx="8"
              fill={i === 0 ? C.light : C.page}
              stroke={i === 0 ? C.rust : C.dark}
              strokeWidth={STROKE.outline}
            />
            <Label x={180} y={y + 20} anchor="middle" lines={lines} />
            {i < STEPS.length - 1 && (
              <line
                x1="180"
                y1={y + BOX_H + 3}
                x2="180"
                y2={y + BOX_H + GAP - 4}
                stroke={C.dark}
                strokeWidth={STROKE.secondary}
                markerEnd={arrow(ID, 'dark')}
              />
            )}
          </g>
        );
      })}
    </Figure>
  );
}
